import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';


@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }


   
  //Setting------------------------------------------------------------------

  GetWeekOff(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetWeekOff', { headers: reqHeader });
  }

  SaveWeekOff(strdata): Observable<any> {
    var param = 'objWeekOff=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/SaveWeekOff?' + encodeURI(param), { headers: reqHeader });
  }


  //Change Password------------------------------------------------------------------

  SaveChangePassword(strdata): Observable<any> {
    var param = 'strChangePassword=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/SaveChangePassword?' + encodeURI(param), { headers: reqHeader });
  }



  //Role------------------------------------------------------------------

  BindBranchRole(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetAllRole', { headers: reqHeader });
  }

  SaveBranchRole(strdata): Observable<any> {
    var param = 'objRoleModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/SaveBranchRole?' + encodeURI(param), { headers: reqHeader });
  }

  RoleMarkActive(strdata): Observable<any> {
    var param = 'objRoleModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/RoleMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

  //Login Report------------------------------------------------------------------

  GetLoginReport(strdata): Observable<any> {
    var param = 'FilterModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetLoginReport?' + encodeURI(param), { headers: reqHeader });
  }



  //Create User------------------------------------------------------------------

  GetCreateUser(strdata): Observable<any> {
    var param = 'FilterModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetCreateUser?' + encodeURI(param), { headers: reqHeader });
  }

  SaveCreateUser(strdata): Observable<any> {
    var param = 'objUser1=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/SaveCreateUser?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllCreateUser(strdata): Observable<any> {
    var param = 'objUser1=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetAllCreateUser?' + encodeURI(param), { headers: reqHeader });
  }

  //Staff Login ------------------------------------------------------------------

  GetStaffLoginID(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetStaffLoginID?' + encodeURI(param), { headers: reqHeader });
  }

  ResetStaffLoginID(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/ResetStaffLoginID?' + encodeURI(param), { headers: reqHeader });
  }

  MarkActiveStaffLoginID(strdata): Observable<any> {
    var param = 'objList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/MarkActiveStaffLoginID?' + encodeURI(param), { headers: reqHeader });
  }

  SaveStaffLoginID(data, list): Observable<any> {
    let formData = new FormData();
    formData.append("ObjStaff", data);
    formData.append("objList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SaveStaffLoginID', formData);
  }

  SendStaffLoginID(list): Observable<any> {
    let formData = new FormData();
    formData.append("objList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SendStaffLoginID', formData);
  }

  GetStaffRole(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetStaffRole?' + encodeURI(param), { headers: reqHeader });
  }

  GetStaffAccessRight(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetStaffAccessRight?' + encodeURI(param), { headers: reqHeader });
  }

  SaveStaffAccessRight(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/SaveStaffAccessRight?' + encodeURI(param), { headers: reqHeader });
  }

  //Student Login ------------------------------------------------------------------

  GetStudentLoginID(strdata): Observable<any> {
    var param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetStudentLoginID?' + encodeURI(param), { headers: reqHeader });
  }

  SaveStudentLoginID(data, list): Observable<any> {
    let formData = new FormData();
    formData.append("ObjStudent", data);
    formData.append("objList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SaveStudentLoginID', formData);
  }

  ResetStudentLoginID(list): Observable<any> {
    let formData = new FormData();
    formData.append("objList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/ResetStudentLoginID', formData);
  }

  MarkActiveStudentLoginID(list): Observable<any> {
    let formData = new FormData();
    formData.append("objList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/MarkActiveStudentLoginID', formData);
  }

  SendStudentLoginID(list): Observable<any> {
    let formData = new FormData();
    formData.append("objList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SendStudentLoginID', formData);
  }

  SaveRoleMap(ObjRole, objList): Observable<any> {
    let formData = new FormData();
    formData.append("ObjRole", ObjRole);
    formData.append("objList", objList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SaveRoleMap', formData);
  }


  //Role Permission ------------------------------------------------------------------ 

  GetBranchRolePermission(ObjRole): Observable<any> {
    var param = 'roleid=' + ObjRole;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetBranchRolePermission?' + encodeURI(param), { headers: reqHeader });
  }


  SaveBranchRolePermission(objRoleModel, RoleList): Observable<any> {
    let formData = new FormData();
    formData.append("objRoleModel", objRoleModel);
    formData.append("RoleList", RoleList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SaveBranchRolePermission', formData);
  }


  //Class Teaches Access Map ------------------------------------------------------------------

  SaveClassTeacherAccessMap(objList, StaffID): Observable<any> {
    let formData = new FormData();
    formData.append("StaffID", StaffID);
    formData.append("objList", objList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SaveClassTeacherAccessMap', formData);
  }

  GetClassTeacherAccessMap(StaffID): Observable<any> {
    var param = 'StaffID=' + StaffID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetClassTeacherAccessMap?' + encodeURI(param), { headers: reqHeader });
  }

  // STAFF USER TYPE MAP------------------------------------------------------------------------

  SaveStaffUserTypeMap(list, data): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", data);
    formData.append("objList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Admin/SaveStaffUserTypeMap', formData);
  }

  GetStaffForUserTypeMap(objModel): Observable<any> {
    var param = 'objModel=' + objModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetStaffForUserTypeMap?' + encodeURI(param), { headers: reqHeader });
  }

  // STAFF USER TYPE MAP------------------------------------------------------------------------

  SaveDashboardAccess(objModel): Observable<any> {
    var param = 'objModel=' + objModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/SaveDashboardAccess?' + encodeURI(param), { headers: reqHeader });
  }

  GetDashboardAccess(objModel): Observable<any> {
    var param = 'objModel=' + objModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Admin/GetDashboardAccess?' + encodeURI(param), { headers: reqHeader });
  }


}
